<!-- components/Loading.vue -->
<template>
  <div>

 
  <div v-if="$store.state.loading" class="loading">
    <img src="https://web.78keji.cn/loading.png" class="spinner" />
    <div style="color: #fff;">加载中...</div>
  </div>
  <div v-if="$store.state.loading1" class="loading1">
    <img src="https://web.78keji.cn/loading.png" class="spinner" />
    <div style="color: #000;">活动已结束</div>
  </div>
   </div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style scoped>
  .loading1 {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff; /* 蒙层背景 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* 蒙层背景 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite; /* 只保留旋转动画 */
  margin-bottom: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>